import { useState, useEffect } from "react";
import { Form, Col, Tooltip } from "antd";
import { FaEdit } from "react-icons/fa";
import { MdCheck } from "react-icons/md";
import { useFilters } from "core/features/filters/store";
import {
    Container,
    Wrapper,
    ButtonApprove,
    ButtonEdit,
    RowField,
    SelectAntd,
    ContentFlex,
    ContainerTable,
    RoundedTable,
    FIlterRight,
    FilterGroup,
    FilterOptions,
    CheckBoxItem,
    ContainerPagination,
    ModalTableContentWrap,
    RowFieldContent,
} from "./styles";
import { FiltrosAvancado } from "../../interfaces/Planejamento";
import column from "./Table";
import Pagination from "./partials/Pagination";
import { useTalhaoJustificativa, useTalhaoJustificativaUpdate } from "../../hooks/useTalhaoJustificativa";
import useModalGestaoJustificativa from "../../hooks/useModalGestaoJustificativa";
import { groupData, setBlocked, setStatusArr } from "./utils";
import { showConfirm, showError, showSuccess } from "infra/helpers/alerta";
import { useAuth } from "core/features/auth/store";
import ModalEditarJustificativa from "./ModalEditarJustificativa";
import { PerfisEnum } from "core/features/users/enums";
import ModalViewTalhaoJustificativa from "./ModalViewTalhaoJustificativa";

type Props = {
    filtrosAvancados?: FiltrosAvancado;
};

function GestaoJustificativa({ filtrosAvancados }: Props) {
    const { Item } = Form;
    const { user } = useAuth();
    const { mutateAsync: updateTalhaoJustificativa } = useTalhaoJustificativaUpdate();
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);
    const [groupByOption, setGroupByOption] = useState("");
    const [n1Aprovado, setN1Aprovado] = useState(false);
    const [n1Pendente, setN1Pendente] = useState(true);
    const [n2Aprovado, setN2Aprovado] = useState(false);
    const [n2Pendente, setN2Pendente] = useState(false);
    const { filters, updateField } = useFilters();
    const { unidade, filtersAdvanced } = filters;
    const {
        setTalhaoJustificado,
        setIsOpenView,
        setIsOpenEdit,
        setId, setIds,
        ids,
        setStatus,
        status,
        talhaoJustificado
    } = useModalGestaoJustificativa();
    const query = {
        UnidadeId: unidade?.id,
        SafraPeriodoId: filtersAdvanced.safraPeriodo,
        PendenteAceiteGerenteUnidade: false, // n2Pendente ? n2Pendente : false,
        PendenteAceiteGerenteRegional: false, // n1Pendente ? n1Pendente : false,
        Page: page,
        Size: size
    }

    const { data: talhaoJustificativaData, refetch } = useTalhaoJustificativa(query);
    const [talhaoJustificativa, setTalhaoJustificativa] = useState(talhaoJustificativaData?.data);

    const resHeader = talhaoJustificativaData?.headers?.paginate ? JSON.parse(talhaoJustificativaData?.headers?.paginate) : {
        currentPage: 0,
        resultsPerPage: 0,
        totalCount: 0
    };

    const perfis = user?.perfis;
    const hasGerenteUnidadePermission = perfis?.some((i) => i?.includes(PerfisEnum.Gerente_Unidade) || i?.includes('Agenda de Campo -Gerente de Unidade'));
    const hasGerenteRegionalPermission = perfis?.some((i) => i === PerfisEnum.Gerente_Regional);
    const hasAdmPermission = perfis?.some((i) => i === PerfisEnum.Administrador);
    const permissions: boolean[] = [!!hasGerenteUnidadePermission, !!hasGerenteRegionalPermission, !!hasAdmPermission];

    useEffect(() => {
        if (talhaoJustificativaData?.data) {
            setTalhaoJustificativa(talhaoJustificativaData.data);
        }
    }, [talhaoJustificativaData?.data]);

    useEffect(() => {
        if (!groupByOption) {
            setTalhaoJustificativa(talhaoJustificativaData?.data);
            return;
        }

        const grouped = groupData(
            talhaoJustificativaData?.data,
            groupByOption
        );

        setTalhaoJustificativa(grouped);
    }, [groupByOption]);

    const groupBy = [
        { label: "Sem agrupamento", value: "" },
        { label: "Tipo de Justificativa", value: "justificativaAtrasoMotivo" },
        { label: "Status de Aprovação", value: "Aprovacao" },
        { label: "Período de Produção", value: "safraPeriodo" },
        { label: "Classe de Operação", value: "operacaoClasse" },
    ];
    let filtered = talhaoJustificativa?.map(item => ({
        ...item,
        status: setStatusArr(item, user, status)
    })).map(item => ({ ...item, blocked: setBlocked(item.status, user) }));

    filtered = filtered?.filter((item) => {
        if (n1Aprovado && item.status === "Aprovado N1") return true;
        if (n1Pendente && item.status === "Pendente N1") return true;
        if (n2Aprovado && item.status === "Aprovado N2") return true;
        if (n2Pendente && item.status === "Pendente N2") return true;
        return false;
    });

    function validarStatusSelecionados(
        filtered: any[],
        ids: Set<string>
    ) {
        const selecionados = filtered.filter(item =>
            ids.has(item.planoOperacionalOperacaoTalhaoId)
        );

        const temN1 = selecionados.some(item => item.status === "Pendente N1");
        const temN2 = selecionados.some(item => item.status === "Pendente N2");

        const pode = (temN1 || temN2) && !(temN1 && temN2);

        const resultado = pode ? selecionados : [];
        return resultado;
    }

    const allIds = filtered?.map((item) => item.planoOperacionalOperacaoTalhaoId);
    const allIdsOk = filtered?.filter(item => ids.has(item.planoOperacionalOperacaoTalhaoId)
        && item.blocked).length || 0;

    const allChecked =
        allIds && allIds?.length > 0 && allIds?.every((id) => ids.has(id));

    const podeContinuar = validarStatusSelecionados(filtered || [], ids);

    async function handleApprove(id?: string) {
        try {
            let tipoParecer = "0";
            let lista = filtered?.filter(item => ids.has(item.planoOperacionalOperacaoTalhaoId));

            if (id) {
                tipoParecer = talhaoJustificado?.justificativaAtrasoAceiteGerenteUnidadeUsuario ? "2" : "1";
            } else {
                const list = lista?.some(p => p.justificativaAtrasoAceiteGerenteUnidadeUsuario)
                tipoParecer = list ? "2" : "1";
            }
            const idsArr = id ? [id] : Array.from(ids);
            const payload = {
                tipoParecer,
                planoOperacionalOperacaoTalhaoIds: idsArr,
            };

            const res = await updateTalhaoJustificativa({ body: payload });

            if (res.status === 204) {
                showSuccess("Justificativa aprovada com sucesso!");
                refetch();
                return;
            }
            showError('Erro ao aprovar justificativa');
        } catch (error) {

        }
    }

    function obterTextoPaginacao(paginaAtual: number, itensPorPagina: number, totalRegistros: number) {
        if (totalRegistros === 0) {
            return 'Mostrando 0 - 0 de 0 registros';
        }

        const inicio = (paginaAtual - 1) * itensPorPagina + 1;
        const fim = Math.min(paginaAtual * itensPorPagina, totalRegistros);

        return `Mostrando ${inicio} - ${fim} de ${totalRegistros} ${totalRegistros === 1 ? 'registro' : 'registros'}`;
    }

    function getDefaultValue() {
        const filtro = filtersAdvanced?.safraPeriodo;
        const filtros = filtrosAvancados?.safraPeriodos;
        if (!filtros?.some(f => f.safraPeriodoId === filtro)) {
            return undefined;
        }
        return filtro;
    }

    return (
        <Container>
            <Wrapper>
                <div style={{ display: "flex", alignItems: "flex-end", marginBottom: 12, justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "flex-end", gap: 12 }}>
                        <div style={{ width: 280 }}>
                            <Item
                                label="Período de Produção"
                                name="periodoProducao"
                                rules={[{ required: true, message: "Período de Produção é obrigatório" }]}
                            >
                                <SelectAntd
                                    onChange={(dataValue: any) => {
                                        updateField("filtersAdvanced", {
                                            ...filtersAdvanced,
                                            safraPeriodo: dataValue
                                        });
                                    }}
                                    placeholder="Período de Produção"
                                    defaultValue={getDefaultValue()}
                                    options={(filtrosAvancados?.safraPeriodos || [])
                                        ?.map((item: any) => ({
                                            label: item.nome,
                                            value: item.safraPeriodoId,
                                        }))}
                                />
                            </Item>
                        </div>
                        <div style={{ width: 200 }}>
                            <SelectAntd
                                onChange={(dataValue: any) => {
                                    setGroupByOption(dataValue);
                                }}
                                placeholder="Agrupar por"
                                options={groupBy}
                                value={groupByOption}
                            />
                        </div>
                        <RowFieldContent>
                            <RowField>
                                <ContentFlex>
                                    <Tooltip title={!(permissions[0] || permissions[1] || permissions[2]) ? "Você não tem permissão para editar justificativas" : "EDITAR EM LOTE"}>
                                        <span style={{ display: "inline-block" }}>
                                            <ButtonEdit
                                                disabled={!(ids.size >= 2 && !(allIdsOk >= 1) && !!podeContinuar.length) || !(permissions[0] || permissions[1] || permissions[2])}
                                                onClick={() => setIsOpenEdit(true)}>
                                                <FaEdit />

                                            </ButtonEdit>
                                        </span>
                                    </Tooltip>
                                    <Tooltip title={!(permissions[0] || permissions[1] || permissions[2]) ? "Você não tem permissão para aprovar justificativas" : "APROVAR EM LOTE"}>
                                        <span style={{ display: "inline-block" }}>
                                            <ButtonApprove
                                                disabled={!(ids.size >= 2 && !(allIdsOk >= 1) && !!podeContinuar.length) || !(permissions[0] || permissions[1] || permissions[2])}
                                                onClick={async () => {
                                                    const { isConfirmed } = await showConfirm("Tem certeza que deseja aprovar essas justificativas?");

                                                    if (!isConfirmed) {
                                                        return;
                                                    }

                                                    handleApprove();

                                                }}>
                                                <MdCheck />

                                            </ButtonApprove>
                                        </span>
                                    </Tooltip>
                                </ContentFlex>
                            </RowField>
                            {
                                ids.size > 0 && (
                                    <div>
                                        {ids.size} justificativa(s) selecionada(s)
                                    </div>
                                )
                            }
                        </RowFieldContent>

                    </div>

                    <Col span={8}>
                        <FIlterRight>
                            <FilterGroup>
                                <span>Gerente Unidade (N1)</span>
                                <FilterOptions>
                                    <CheckBoxItem>
                                        <label>
                                            <input type="checkbox" checked={n1Aprovado} onChange={(e) => {
                                                setN1Aprovado(!n1Aprovado);
                                                setN2Pendente(false);
                                                setN2Aprovado(false);
                                                e.target.checked ? setStatus("Aprovado N1") : setStatus("");
                                            }} />
                                            Aprovados
                                        </label>
                                    </CheckBoxItem>
                                    <CheckBoxItem>
                                        <label>
                                            <input type="checkbox" checked={n1Pendente} onChange={() => {
                                                setN1Pendente(!n1Pendente);
                                                setN2Pendente(false);
                                                setN2Aprovado(false);
                                            }} />
                                            Pendentes
                                        </label>
                                    </CheckBoxItem>
                                </FilterOptions>
                            </FilterGroup>
                            <FilterGroup>
                                <span>Gerente Regional (N2)</span>
                                <FilterOptions>
                                    <CheckBoxItem>
                                        <label>
                                            <input type="checkbox" checked={n2Aprovado} onChange={() => {
                                                setN2Aprovado(!n2Aprovado);
                                                setN1Aprovado(false);
                                                setN1Pendente(false);
                                            }} />
                                            Aprovados
                                        </label>
                                    </CheckBoxItem>
                                    <CheckBoxItem>
                                        <label>
                                            <input type="checkbox" checked={n2Pendente} onChange={(e) => {
                                                setN2Pendente(!n2Pendente);
                                                setN1Aprovado(false);
                                                setN1Pendente(false);
                                                e.target.checked ? setStatus("Pendente N2") : setStatus("");
                                            }} />
                                            Pendentes
                                        </label>
                                    </CheckBoxItem>
                                </FilterOptions>
                            </FilterGroup>
                        </FIlterRight>
                    </Col>
                </div>
            </Wrapper>
            {
                !filtersAdvanced?.safraPeriodo ? (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                        <p>Selecione um período de produção para exibir o calendario</p>
                    </div>
                ) : (
                    <>
                        <ModalTableContentWrap>
                            <ContainerTable>
                                <RoundedTable
                                    style={{ marginBottom: 16 }}
                                    rowKey="key"
                                    columns={column(
                                        setTalhaoJustificado,
                                        setIsOpenView,
                                        setIsOpenEdit,
                                        groupByOption,
                                        setId,
                                        ids,
                                        setIds,
                                        filtered || [],
                                        allChecked || false,
                                        handleApprove
                                    )}
                                    dataSource={filtered}
                                    className={`${groupByOption ? 'grouped-table' : ''}`}
                                    scroll={{
                                        y: '100%',
                                    }}
                                    sticky
                                    pagination={false}
                                    rowClassName={(record: any) =>
                                        record.type === 'group' ? 'group-row' : ''
                                    }
                                />
                            </ContainerTable>
                        </ModalTableContentWrap>
                        <ContainerPagination>
                            <div>
                                <span>{obterTextoPaginacao(page, size, resHeader?.totalCount || 0)}</span>
                            </div>
                            <div>
                                <Pagination
                                    page={page}
                                    size={size}
                                    total={resHeader?.totalCount || 0}
                                    onChange={(p, s) => {
                                        setPage(p);
                                        setSize(s);
                                    }}
                                />
                            </div>
                        </ContainerPagination>
                    </>
                )
            }
            <ModalViewTalhaoJustificativa permission={permissions} />
            <ModalEditarJustificativa lista={filtered?.filter(item => ids.has(item.planoOperacionalOperacaoTalhaoId))} refetch={refetch} />
        </Container>
    )
}

export default GestaoJustificativa;